import React from 'react'
import { Redirect, useParams } from 'react-router'
import { RouteParams } from 'constants/routes'
import NotFoundView from 'views/NotFoundView'
import { useVersioning } from 'modules/versioning'
import { useGetArtboardInDocumentWithUuidQuery } from 'gqlTypes'
import { DynamicLoadingPage } from 'containers/DynamicLoadingPage'

/**
 * In some places, like when navigating to an artboard in the canvas view, we only
 * have access to the artboard UUID. This component allows to navigate to the normal
 * artboard view by using the uuid instead of the artboard permanent short id.
 */
export default function ArtboardUuidRedirect() {
  const { shareID, artboardUUID } = useParams<
    RouteParams<'ARTBOARD_DETAIL_UUID'>
  >()

  const versionContext = useVersioning()
  const { getPathname } = versionContext

  const documentId = versionContext.loading
    ? null
    : versionContext.currentVersion.document?.identifier

  const { data, loading } = useGetArtboardInDocumentWithUuidQuery({
    variables: {
      documentId: documentId || '',
      artboardUuid: artboardUUID,
    },
    skip: versionContext.loading,
  })

  const matchingArtboardPermanentShortId =
    data?.artboardInDocumentWithUuid?.permanentArtboardShortId

  if (loading || versionContext.loading) {
    return <DynamicLoadingPage />
  }

  if (!matchingArtboardPermanentShortId) {
    return <NotFoundView />
  }

  const artboardRoutePathname = getPathname({
    routeKey: 'ARTBOARD_DETAIL',
    routeParams: {
      shareID: shareID,
      permanentArtboardShortId: matchingArtboardPermanentShortId,
    },
  })

  return <Redirect to={artboardRoutePathname} push={false} />
}
